import { useState } from 'react'

import ConfirmationDialog from '../ConfirmationDialog/index'
import styles from './MultiPhoneBlacklist.module.scss'

const MultiPhoneBlacklist = ({ handleConfirm, handleCancel }) => {
  const [phones, setPhones] = useState([])
  const [step, setStep] = useState(1)

  function handleChange(e) {
    const parsed = e.target.value
      .trim()
      .replace(/[\s,;\n]+/gm, '$')
      .split('$')

    setPhones(parsed)
  }

  function handleSubmitPhones(e) {
    e.preventDefault()
    if (phones.length > 0) {
      setStep(2)
    }
  }

  if (step === 1) {
    return (
      <Step1
        handleCancelConfirmation={handleCancel}
        handleSubmitMails={handleSubmitPhones}
        handleChange={handleChange}
        phones={phones}
      />
    )
  }

  if (step === 2) {
    return (
      <Step2
        handleSubmitConfirmation={() => handleConfirm(phones)}
        handleCancelConfirmation={handleCancel}
        phones={phones}
      />
    )
  }

  return null
}

const Step1 = ({ handleSubmitMails, handleChange, phones, handleCancelConfirmation }) => {
  return (
    <ConfirmationDialog
      title="Exclude multiple phones"
      onConfirm={handleSubmitMails}
      actLikeForm
      isButtonDisabled={phones.length < 1}
      onReject={handleCancelConfirmation}
      onClose={handleCancelConfirmation}
    >
      <div className={styles.container}>
        <textarea
          placeholder="Enter numbers seperated by space, comma, semicolon or enter"
          onChange={handleChange}
        ></textarea>
      </div>
    </ConfirmationDialog>
  )
}

const Step2 = ({ handleSubmitConfirmation, handleCancelConfirmation, phones }) => (
  <ConfirmationDialog
    title={`Do you want to blacklist ${phones.length} phones?`}
    onClose={handleCancelConfirmation}
    onConfirm={handleSubmitConfirmation}
    handleCancel={handleCancelConfirmation}
    theme="blacklist"
    positiveMessage="Yep"
    negativeMessage="Nope"
    onPressEnter={handleSubmitConfirmation}
    hasDangerousAction
  >
    <div className={styles.dialogContainer}>
      <ul>
        {phones.map(e => (
          <li key={e}>{e}</li>
        ))}
      </ul>
    </div>
  </ConfirmationDialog>
)

export default MultiPhoneBlacklist
